import { render, staticRenderFns } from "./HistoryItemContainer.vue?vue&type=template&id=176f8d00"
import script from "./HistoryItemContainer.vue?vue&type=script&lang=js"
export * from "./HistoryItemContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports